import { render, staticRenderFns } from "./vmMediafile.vue?vue&type=template&id=26758047&scoped=true&"
import script from "./vmMediafile.vue?vue&type=script&lang=js&"
export * from "./vmMediafile.vue?vue&type=script&lang=js&"
import style0 from "./vmMediafile.vue?vue&type=style&index=0&id=26758047&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26758047",
  null
  
)

export default component.exports